<template>
  <header
    class="fixed top-0 left-0 right-0 z-50 flex justify-between items-center px-8 py-2 backdrop-blur-md shadow-xl w-full mx-auto bg-white/20"
  >
    <div>
      <a href="/" class="block">
        <img
          src="~/assets/img/meditationcircle-logo.svg"
          alt="Logo"
          class="w-12 sm:w-16"
        />
      </a>
    </div>

    <!-- Mobile Join via Zoom button -->
    <div class="md:hidden mr-2">
      <a
        href="https://us02web.zoom.us/s/7949814037"
        class="bg-white font-semibold border border-blue-500 text-blue-500 flex items-center gap-1 px-2 py-1 rounded-lg shadow-lg text-sm"
      >
        <span>Join via</span>
        <img src="~/assets/img/zoom.svg" alt="Zoom" class="w-14" />
      </a>
    </div>

    <!-- Desktop Menu -->
    <div class="hidden md:flex items-center gap-4 text-brand-dark font-semibold">
      <a
        @click.prevent="navigateToSection('podcast-section')"
        href="/#podcast-section"
        class="flex items-center gap-2 py-2 rounded-md cursor-pointer"
      >
        <img src="~/assets/img/Record.svg" alt="Record" class="w-8" />
        Recorded Meditations</a
      >
      <ul class="flex gap-4">
        <li>
          <a
            @click.prevent="navigateToSection('about-section')"
            href="/#about-section"
            class="cursor-pointer"
            >About Us</a
          >
        </li>
        <li>
          <a
            @click.prevent="navigateToSection('contact-section')"
            href="/#contact-section"
            class="cursor-pointer"
            >Contact Us</a
          >
        </li>
        <li>
          <a
            @click.prevent="navigateToSection('faq-section')"
            href="/#faq-section"
            class="cursor-pointer"
            >F.A.Q</a
          >
        </li>
      </ul>
    </div>

    <!-- Join via Zoom button - desktop -->
    <div class="hidden md:block">
      <a
        href="https://us02web.zoom.us/s/7949814037"
        class="bg-white font-semibold border border-blue-500 text-blue-500 flex items-center gap-2 px-4 py-2 rounded-xl shadow-lg"
        >Join via <img src="~/assets/img/zoom.svg" alt="Zoom" class="w-16"
      /></a>
    </div>

    <!-- Mobile hamburger button -->
    <button @click="mobileMenuOpen = !mobileMenuOpen" class="md:hidden text-brand-dark">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-8 w-8"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          v-if="!mobileMenuOpen"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 6h16M4 12h16M4 18h16"
        />
        <path
          v-else
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </header>

  <!-- Mobile menu dropdown -->
  <div
    v-if="mobileMenuOpen"
    class="md:hidden fixed top-[72px] left-0 right-0 bg-white shadow-xl p-4 z-50"
  >
    <div class="flex flex-col gap-4 text-brand-dark font-semibold">
      <a
        @click.prevent="
          navigateToSection('podcast-section');
          mobileMenuOpen = false;
        "
        href="/#podcast-section"
        class="flex items-center gap-2 px-4 py-2 rounded-md cursor-pointer"
      >
        <img src="~/assets/img/Record.svg" alt="Record" class="w-8" />
        Recorded Meditations</a
      >
      <ul class="flex flex-col gap-4 pl-4">
        <li><a href="/" class="cursor-pointer">Home</a></li>
        <li>
          <a
            @click.prevent="
              navigateToSection('about-section');
              mobileMenuOpen = false;
            "
            href="/#about-section"
            class="cursor-pointer"
            >About Us</a
          >
        </li>
        <li>
          <a
            @click.prevent="
              navigateToSection('contact-section');
              mobileMenuOpen = false;
            "
            href="/#contact-section"
            class="cursor-pointer"
            >Contact Us</a
          >
        </li>
        <li>
          <a
            @click.prevent="
              navigateToSection('faq-section');
              mobileMenuOpen = false;
            "
            href="/#faq-section"
            class="cursor-pointer"
            >F.A.Q</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const mobileMenuOpen = ref(false);

const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    // Using CSS for smoother scrolling with ease-in-out
    document.documentElement.style.scrollBehavior = "smooth";
    element.scrollIntoView({
      block: "start"
    });
    // Reset scroll behavior after animation
    setTimeout(() => {
      document.documentElement.style.scrollBehavior = "";
    }, 1000);
  }
};

const navigateToSection = (sectionId) => {
  if (window.location.pathname === "/") {
    // If already on home page, just scroll
    scrollToSection(sectionId);
  } else {
    // If on another page, navigate to home with the hash
    router.push("/#" + sectionId);
  }
};
</script>

<style scoped>
/* Add a transition for the mobile menu */
.md\:hidden {
  transition: all 0.3s ease;
}

/* Add smooth scrolling for the entire page with ease-in-out */
:global(html) {
  scroll-behavior: smooth;
  scroll-snap-type: y proximity;
}

:global(html[style*="scroll-behavior"]) {
  scroll-behavior: smooth !important;
  transition-timing-function: ease-in-out !important;
  transition-duration: 800ms !important;
}
</style>
